/**
 * Sets the address fields of a form based on customer data.
 *
 * @param {Object} options - Options for setting customer form fields.
 * @param {Object} options.customer - The customer data.
 * @param {Object} options.form - The form instance.
 * @returns {void}
 */
export const setCustomerFields = ({ customer, form }) => {
  // Set address-related fields in the form if available in customer data
  if (customer?.user?.address) {
    form.setFieldsValue({
      invoicing_address: `${customer?.user?.address?.number} ${customer?.user?.address?.street}`,
      postal_code: customer?.user?.address?.postal_code,
      city: customer?.user?.address?.city
    });
  }
};
